import { Component, Input } from '@angular/core';
import { filter, map, switchMap, take, tap } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { StaticPageService } from '../../../shared/services/static-page.service';
import { MatDialog } from '@angular/material/dialog';
import { BureauResponse } from '../../../shared/models/static-model/bureau.model';
import { ReaderPdfComponent } from '../../../shared/inputs/reader-pdf/reader-pdf.component';
import { TableGeneralSimpleComponent } from '../../../shared/components-generals/table-general-simple/table-general-simple.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-bureau-consultation',
  templateUrl: './bureau-consultation.component.html',
  imports: [TranslateModule, TableGeneralSimpleComponent],
})
export class BureauConsultationComponent {
  @Input() quotationId = 0;
  public dataSource = new MatTableDataSource<any>([]);
  public headers: { value: string; description: string }[] = [];
  public bureauResponse: BureauResponse | null = null;
  public payload!: {
    quotationId: number;
    idCover: number;
    idUsuario: string;
    persona: string;
  };

  constructor(
    private staticPageService: StaticPageService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.getDataTable();
  }

  public getDataTable() {
    this.staticPageService
      .getBureauInitialData(this.quotationId)
      .pipe(
        take(1),
        filter((data) => Boolean(data?.iD_CARATULA && data?.persona && data?.tipo)),
        map((data) => ({
          quotationId: this.quotationId,
          idCover: data ? data.iD_CARATULA : 0,
          idUsuario: data ? data.tipo : '',
          persona: data ? data.persona : '',
        })),
        switchMap((payload) => {
          this.payload = payload;
          return this.staticPageService.getBureauData(payload).pipe(take(1));
        }),
      )
      .subscribe({
        next: (bureauData) => {
          this.bureauResponse = bureauData;
          this.dataSource.data = bureauData!.queries.map((doc: any) => {
            return {
              Documento: doc.aP_MATERNO,
              aP_PATERNO: doc.aP_PATERNO,
              fecha: doc.fecha,
              hora: doc.hora,
              iD_CARATULA: doc.iD_CARATULA,
              iD_CONSULTA_BURO: doc.iD_CONSULTA_BURO,
              iD_COTIZACION: doc.iD_COTIZACION,
              nombre: doc.nombre,
              persona: doc.persona,
              tipo: doc.tipo,
              tipO_STR_SALIDA: doc.tipO_STR_SALIDA,
              usuario: doc.usuario,
            };
          });
          if (bureauData!.queries.length) {
            this.headers = Object.keys(this.dataSource.data[0]).map((key) => ({
              value: key,
              description: key,
            }));
          }
        },
        error: (err) => console.error('❌ Error al obtener bureau:', err),
      });
  }

  public newQuery(): void {
    const persona = this.payload.persona?.toUpperCase?.() || '';

    let personType = 3; // valor por defecto MORAL
    if (persona === 'FISICA') {
      personType = 1;
    } else if (persona === 'FISICA CON ACT. EMPRESARIAL') {
      personType = 2;
    }

    const payload = {
      quotationId: this.payload.quotationId,
      coverId: this.payload.idCover,
      userId: 1,
      personType,
    };

    this.staticPageService
      .newBureauData(payload)
      .pipe(take(1))
      .subscribe(() => {
        this.getDataTable();
      });
  }

  getPdf(id: string | number) {
    const dialogRef = this.dialog.open(ReaderPdfComponent, {
      width: '750px',
      height: 'auto',
      data: {
        quotationId: this.quotationId,
        ulrPDF: 'buro',
      },
    });
  }
}
